/**
 * Names of widgets which can be referenced in `dashboardLayout`.
 * Layout entries are either a plain widget name or `"<className>;<WidgetName>"` inside a row array.
 */ export const WIDGET_NAMES = [
    'AgpTrendChartWidget',
    'TrendChartWidget',
    'ChartControls',
    'MeasurementsTableWidget',
    'MeasurementsTableWidgetWithoutMyDownloads',
    'GlucoseLevelDistributionWidget',
    'MixedDistributionWidget',
    'SummaryTableWidget',
    'ContentBar',
    'KPIs',
    'PatientHeader',
    'BloodGlucoseConcentrationReport',
    'GlucoseConcentrationLevelsWidget',
    'DaysSelector',
    'PrintableAgpBgmReport'
];
